// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"65":"e23a88fa","905":"fe96606d"}[chunkId] + ".js";
};